import React, { HTMLAttributes } from 'react'

import { VariantProps, cva } from 'class-variance-authority'
import clsx from 'clsx'

export type CardProps = HTMLAttributes<HTMLDivElement> & {
  children?: React.ReactElement | Array<React.ReactElement>
  dataTestId?: string
} & VariantProps<typeof cardVariants>

export type CardSectionProps = HTMLAttributes<HTMLDivElement> & {
  children?: React.ReactElement | Array<React.ReactElement>
}

const cardVariants = cva('rounded-md', {
  defaultVariants: {
    hasSections: false,
    theme: 'primary'
  },
  variants: {
    hasSections: {
      false: 'p-6',
      true: 'divide-y'
    },
    theme: {
      alternative: 'border border-border-default bg-background-alternative',
      primary: 'border border-border-muted bg-background-default'
    }
  }
})

/**
 * Card - A surface that differentiates itself from the background
 */

export const Card = React.forwardRef<HTMLDivElement, CardProps>(function Card(
  { children, className, dataTestId, hasSections, theme },
  ref
) {
  return (
    <div className={clsx(cardVariants({ hasSections, theme }), className)} data-testid={dataTestId} ref={ref}>
      {children}
    </div>
  )
})

Card.displayName = 'Card'

export const CardSection = ({ children, className }: CardSectionProps) => {
  return <div className={clsx(className, 'p-6')}>{children}</div>
}
